import { PopoverPlacement } from "@idui/react-popover";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { useSelectItemsTranslate } from "@ryde/redux";
import { DirectionEnum, IStyledAttributes, removeSlash } from "@ryde/shared";

const DirectionTitleWrapper = styled.span.attrs<IStyledAttributes>({
  "data-e2e": "direction-title-wrapper",
})`
  display: flex;
  align-items: center;
`;

interface IRideHeaderDirection {
  direction: DirectionEnum;
}

export const RideHeaderDirection: FC<IRideHeaderDirection> = ({
  direction,
}) => {
  const { t } = useTranslation();
  const { translateLabel } = useSelectItemsTranslate();

  return (
    <FramerTooltip
      placement={PopoverPlacement.bottom}
      content={t("ride.formLabel.direction")}
    >
      <DirectionTitleWrapper>
        {direction === DirectionEnum.PickUp && <SVG_MUI.OvalTo2SVG />}
        {direction === DirectionEnum.DropOff && <SVG_MUI.OvalBack2SVG />}
        {direction === DirectionEnum.Both && <SVG_MUI.OvalBoth2SVG />}
        {direction === DirectionEnum.None && <SVG_MUI.OvalNone2SVG />}
        <label> {translateLabel(`Dir${removeSlash(direction)}`)} </label>
      </DirectionTitleWrapper>
    </FramerTooltip>
  );
};
